import SYSTEM_MODULES from './modules';
import NOTIFICATIONS from './notifications';
import SOCKETS from './sockets';
import BASE_ROLES from './base-roles';
import MESSAGES from './messages';
import TIME from './time';
import DATE from './date';
import ANNOUNCEMENTS from './announcements';
import MATERIALS from './materials';
import INTERNET_CONNECTION_STATUS from './internet-connection-status';
import LINKS from './links';
import ENVIRONMENTS from './environments';
import ERROR_CODES from './error-codes';
import SORTING from './sorting';
import DUMMY_DATA from './dummyData';
import ASSESSMENTS from './assessments';
var SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
export { default as colors } from './colors';
export { default as regex } from './regex';
export { default as ERROR_MESSAGES } from './error-messages';
export { default as GRADEBOOK_SYSTEMS } from './gradebook-systems';
export { default as USER_PERMISSIONS } from './user-permissions';
export { default as QUESTIONS } from './questions';
export { default as STORAGE_KEYS } from './storage-keys';
export { default as certificate } from './certificates';
export { SOCKET_URL, ERROR_CODES, ENVIRONMENTS }; // TODO: Refactor this export default to be like export { default as   } if it's from file
// or export direct if it's a constant in this file

export default {
  API_URL: "".concat(process.env.REACT_APP_API_URL, "/v0"),
  API_URL_V1: "".concat(process.env.REACT_APP_API_URL, "/v1"),
  API_URL_V2: "".concat(process.env.REACT_APP_API_URL, "/v2"),
  API_URL_V3: "".concat(process.env.REACT_APP_API_URL, "/v3"),
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL,
  WEB_URL: process.env.REACT_APP_WEB_URL,
  SYSTEM_MODULES: SYSTEM_MODULES,
  ERROR_CODES: ERROR_CODES,
  NOTIFICATIONS: NOTIFICATIONS,
  SOCKETS: SOCKETS,
  BASE_ROLES: BASE_ROLES,
  MESSAGES: MESSAGES,
  TIME: TIME,
  DATE: DATE,
  ANNOUNCEMENTS: ANNOUNCEMENTS,
  MATERIALS: MATERIALS,
  JWT_VERSION: 1,
  INTERNET_CONNECTION_STATUS: INTERNET_CONNECTION_STATUS,
  LINKS: LINKS,
  SORTING: SORTING,
  DUMMY_DATA: DUMMY_DATA,
  ASSESSMENTS: ASSESSMENTS
};